import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import CategorySection from './components/CategorySection';
import FeaturedSection from './components/FeaturedSection';
import ArticleSection from './components/ArticleSection';
import FAQSection from './components/FAQSection';
import CTASection from './components/CTASection';

export default function Home() {
  return (
    <>
      <Navbar />
      <main>
        <HeroSection />
        <CategorySection />
        <FeaturedSection />
        <CTASection />
        <ArticleSection />
        <FAQSection />
      </main>
      <Footer />

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'WebPage',
            name: '韩漫之家 - 韩漫下载安装与韩漫离线免费下载 | 韩漫APK',
            description:
              '韩漫之家提供韩漫下载安装服务，支持韩漫离线免费下载到手机，韩漫APK轻松获取，随时随地离线看韩漫全集。',
            url: 'https://hanmanzhijia.com/',
            isPartOf: {
              '@type': 'WebSite',
              name: '韩漫之家',
              url: 'https://hanmanzhijia.com/',
            },
            breadcrumb: {
              '@type': 'BreadcrumbList',
              itemListElement: [
                {
                  '@type': 'ListItem',
                  position: 1,
                  name: '首页',
                  item: 'https://hanmanzhijia.com/',
                },
              ],
            },
          }),
        }}
      />

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'FAQPage',
            mainEntity: [
              {
                '@type': 'Question',
                name: '韩漫之家APK是否免费下载？',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: '是的，韩漫之家APK完全免费下载。您可以直接从我们的官方网站下载最新版本的APK安装包，无需支付任何费用。',
                },
              },
              {
                '@type': 'Question',
                name: '如何将韩漫离线下载到手机？',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: '在韩漫之家APP中，找到您想下载的漫画，进入详情页后点击"离线下载"按钮即可。',
                },
              },
              {
                '@type': 'Question',
                name: '韩漫之家支持哪些手机系统？',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: '韩漫之家目前支持Android 6.0及以上版本的安卓手机。',
                },
              },
              {
                '@type': 'Question',
                name: '下载的韩漫会占用多少手机存储空间？',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: '每话韩漫大约占用5-15MB的存储空间，具体取决于漫画的页数和画质。',
                },
              },
              {
                '@type': 'Question',
                name: '如何获取最新的韩漫更新通知？',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: '您可以在韩漫之家APP中订阅喜欢的漫画作品，当有新章节更新时会自动推送通知。',
                },
              },
            ],
          }),
        }}
      />
    </>
  );
}